import { SET_ORGANIZATION_MEMBERS, ADD_ORGANIZATION_MEMBER, UPDATE_ORGANIZATION_MEMBER, DELETE_ORGANIZATION_MEMBER } from './actions';

const INITIAL_STATE = null;

const organizationMemberReducer = (state = INITIAL_STATE, action) => {
     const orgMembers = state ? [...state] : state;

     switch (action.type) {
          case SET_ORGANIZATION_MEMBERS: {
               return action.payload;
          }

          case ADD_ORGANIZATION_MEMBER: {
               orgMembers.push(action.payload);
               return orgMembers;
          }

          case UPDATE_ORGANIZATION_MEMBER: {
               for (let i = 0; i < orgMembers.length; i++) {
                    const orgMember = orgMembers[i];

                    if (orgMember.email === action.payload.email) {
                         orgMembers[i] = {
                              ...orgMember,
                              ...action.payload,
                         };

                         break;
                    }
               }

               return orgMembers;
          }

          case DELETE_ORGANIZATION_MEMBER: {
               return orgMembers.filter((orgMember) => orgMember.orgUserId !== action.payload);
          }

          default:
               return state;
     }
};

export const getOrganizationMemberById = (state, id) =>
     state.subscriber.organizationMembers?.find((organizationMember) => organizationMember.id === id);

export default organizationMemberReducer;
